module.exports = __webpack_public_path__ + "img/program-image.f6721d30.png";